import { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from './ui/button';

/**
 * InstallPWA — floating button to trigger the native PWA install prompt.
 * Only visible on browsers that support beforeinstallprompt (Chrome, Edge, Brave).
 */
export default function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setPrompt(null);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    // Check if already installed (running in standalone)
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setInstalled(true);
    }
    // Respect previous dismiss for the session
    if (sessionStorage.getItem('muzi_install_hidden') === '1') {
      setHidden(true);
    }
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    try {
      await prompt.userChoice;
    } catch (err) {
      console.error('[InstallPWA] userChoice failed:', err);
    }
    setPrompt(null);
  };

  const dismiss = () => {
    sessionStorage.setItem('muzi_install_hidden', '1');
    setHidden(true);
  };

  if (installed || hidden || !prompt) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-40 md:bottom-6 md:left-auto md:right-6 md:translate-x-0 animate-in slide-in-from-bottom-4">
      <div className="glass rounded-2xl p-3 pr-4 flex items-center gap-3 border border-pink-500/30 shadow-2xl shadow-pink-500/20">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-pink-500 via-purple-600 to-blue-500 flex items-center justify-center text-white font-black">
          M
        </div>
        <div className="min-w-0">
          <div className="text-sm font-bold text-white">Installe MUZI</div>
          <div className="text-[11px] text-zinc-400">Accès rapide depuis ton bureau</div>
        </div>
        <Button onClick={handleInstall} className="btn-neon h-9 px-3 text-xs font-bold rounded-xl text-white border-0">
          <Download size={14} className="mr-1" /> Installer
        </Button>
        <button onClick={dismiss} className="w-7 h-7 rounded-lg hover:bg-white/10 text-zinc-400 hover:text-white flex items-center justify-center" aria-label="Fermer">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
